import z from 'zod';

export const createSessionSchema = z.object({
  email: z
    .email({
      error: 'E-mail é obrigatória e deve ser válido (ex: exemplo@exemplo.com)',
    })
    .toLowerCase()
    .trim(),
  password: z.string({
    error: 'Senha é obrigatória',
  }),
});

export type CreateSessionPayload = z.infer<typeof createSessionSchema>;
